/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

/**
 * Board filter each funnel stage opens, so a click continues the work.
 *
 * Preserved through the overview redesign although the new screen links to
 * the unfiltered board: this map is the only written record of which stored
 * stage each funnel bucket meant, and the per-stage click comes back the
 * moment the board can be addressed by one.
 *
 * The parameter is `stages`, plural and comma-separated -- what
 * `useAttendanceFilters` actually reads. The old links said `stage`, which
 * the page ignores, so every "open this stage" link on the overview had
 * been opening the whole board.
 */
export const STAGE_FILTER: Record<string, string> = {
  // Both stages the server counts as an active lead (`_LEAD_STAGES`).
  active_leads: 'new,contacted',
  in_negotiation: 'visiting',
  // `proposal` and `negotiation` collapsed into one column: the board
  // already showed them together.
  proposal_sent: 'negotiating',
  closed_this_month: 'won',
};

/**
 * The attendances board, filtered to one funnel bucket.
 *
 * @param agencyId - Active agency
 * @param bucket - A key of {@link STAGE_FILTER}
 * @returns The board URL, unfiltered when the bucket is not known
 */
export function stageBoardUrl(agencyId: string, bucket: string): string {
  const stage = STAGE_FILTER[bucket];
  const query = stage ? `?stages=${stage}` : '';
  return `/app/agencies/${agencyId}/attendances${query}`;
}
